import { Box, ResponsiveRender, Skeleton, Text } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import PageTitle from '@/components/page-title'
import { Header } from './header/header'
import { ActionsSection } from './actions-section'
import { ListingAddress } from '../../components/listing-address'
import { ListingInfo } from '../../components/listing-info'
import { PublicLinkField } from '../../components/public-link-field'
import { ContentSection } from '../../components/content-section'
import { SectionHeader } from '../../components/section-header'
import { TrackPerformanceLink } from '../../components/track-performance-link'
import { AnalyticIndicators } from '../../components/analytic-indicators'
import { Insights } from '../../components/insights'
import { Recommendations } from '../../components/recommendations'
import { RequiredActionBanner } from '../../components/required-action-banner'
import { Footer } from '../../components/footer'
import { useListingData } from '../../context/listing-data'
import { CoverImage } from '../../components/cover-image'

export const MobileLayout = () => {
  const { t } = useTranslation()
  const { loading } = useListingData()

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="large"
      paddingBottom="xxlarge"
      paddingTop="xsmall"
    >
      <PageTitle>
        <Text>{t('Dashboard')}</Text>
      </PageTitle>

      <Box display="flex" flexDirection="column" gap="large" paddingX="gutter">
        <Header />
        <Box display="flex" gap="large" alignItems="center">
          <ResponsiveRender above="mobile" below="desktop">
            <Box borderRadius="standard" boxShadow="small" style={{ height: '168px' }}>
              <CoverImage />
            </Box>
          </ResponsiveRender>
          <Box
            display="flex"
            flexDirection="column"
            gap="large"
            width="full"
            style={{ maxWidth: '528px' }}
          >
            {loading ? (
              <Skeleton.Text lineCount={2} />
            ) : (
              <Box display="flex" flexDirection="column" gap="small">
                <ListingAddress />
                <ListingInfo />
              </Box>
            )}
            <PublicLinkField />
          </Box>
        </Box>
        <RequiredActionBanner />
        {loading ? <Skeleton.Header /> : <ActionsSection />}
      </Box>

      <ContentSection testId="analytics-section">
        {loading ? (
          <Skeleton.Header />
        ) : (
          <SectionHeader title={t('Analytics')} badge="NEW">
            <TrackPerformanceLink />
          </SectionHeader>
        )}
        <AnalyticIndicators />
        <Insights />
      </ContentSection>
      <ContentSection testId="recommendations-section">
        {loading ? <Skeleton.Header /> : <SectionHeader title={t('Recommended for you')} />}
        <Recommendations />
      </ContentSection>
      <Box paddingX="gutter">
        <Footer />
      </Box>
    </Box>
  )
}
